var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"loading"}},[_c('div',{staticStyle:{"padding-top":"150px"}},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":50,"width":50},on:{"animCreated":_vm.handleAnimation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }